export default "__VITE_ASSET__BOyDFGG7__"